import React, { Suspense } from 'react';
import ObservableAutoSizer from '@vromo/ui/components/ObservableAutoSizer';
import { useStore } from '@vromo/mobx-react/mobx-react';
import TrackingLinkStore from '@vromo/tracking-link/TrackingLinkStore';
import { observer } from 'mobx-react-lite';

const TrackingMap = React.lazy(() => import(/* webpackPrefetch: true */ '../../TrackingMap.lazy'));

const MapWrapper = observer(() => {
    const rootStore = useStore<TrackingLinkStore>('rootStore');
    const job = rootStore.jobs.first()!;
    const icon = job?.campaign?.theme?.icon?.url || '';

    return (
        <ObservableAutoSizer
            customChildren={({ width, height }) =>
                width && height ? (
                    <Suspense
                        fallback={<div style={{ width, height, backgroundColor: '#F3F3F3' }} />}>
                        <TrackingMap {...{ icon, width, height }} />
                    </Suspense>
                ) : null
            }
        />
    );
});

export default MapWrapper;
